import React from 'react';
import { SessionContext } from '@benzinga/session-context';
import { NotificationManager, NotificationsManagerEvent } from '@benzinga/notification-manager';
import { DesktopNotificationManager } from '@benzinga/desktop-notification-manager';
import Hooks from '@benzinga/hooks';

export const GlobalPriceAlertMonitor: React.FC = () => {
  const session = React.useContext(SessionContext);
  const notificationManager = session.getManager(NotificationManager);

  const generateNotification = React.useCallback(
    (symbol: string, triggerType: string, triggerPrice: number) => {
      session.getManager(DesktopNotificationManager).dispatchNotification('Price Alert', {
        body: `${symbol} went ${triggerType === 'UP' ? 'above' : 'below'} ${triggerPrice}`,
      });
    },
    [session],
  );

  Hooks.useSubscriber(notificationManager, (event: NotificationsManagerEvent) => {
    if (event.type === 'notifications:update') {
      const notifications = notificationManager.getNotifications();
      const latestNotification = notifications?.[0];
      if (latestNotification?.type === 'price_alert') {
        const data = latestNotification.data?.metadata;
        const symbol = data?.dispatchPayload ?? data?.symbol;
        if (symbol && data?.triggerType !== undefined && data?.triggerPrice !== undefined) {
          generateNotification(symbol, data.triggerType, data.triggerPrice);
        }
      }
    }
  });

  return null;
};
